
/**
 * Use in case a pause is needed between a PUT and a subsequent GET.
 * 
 * @param millis Number of milliseconds to wait
 */
export async function wait(millis: number) {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => resolve(), millis);
  });

  await promise;
}

